/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'flag': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M17 12.75V35h-.03c.02 0 .03-.086.03 0 0 .69-.672 1.125-1.5 1.125s-1.5-.372-1.5-1.062c0-.086.011-.063.03-.063H14V12.75c0-.69.672-1.25 1.5-1.25s1.5.56 1.5 1.25zm1.871.238c-.501-.233-.871-.04-.871.512v11c0 .552.37 1.255.871 1.488C19.815 26.425 21.524 27 24 27c3.759 0 5.31-3.091 10.047-1.804.533.145.953-.144.953-.696v-11c0-.552-.42-1.159-.953-1.304C29.31 10.909 27.759 14 24 14c-2.476 0-4.185-.575-5.129-1.012z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/flag.js